/**
 * Controls for the reading surfaces.
 *
 * Replaces five 64px PNGs in `public/navigation-icons/` (~292 KB) that were
 * rendered at a fixed size and could not follow a hover or disabled state.
 * Same stroke language as the dash nav.
 */

const Svg = ({ children }) => (
    <svg
        className="deck-icon"
        viewBox="0 0 32 32"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
)

export const ShuffleIcon = () => (
    <Svg>
        <rect x="5.5" y="8" width="13" height="19" rx="2" transform="rotate(-11 12 17.5)" />
        <rect x="13.5" y="5" width="13" height="19" rx="2" transform="rotate(11 20 14.5)" />
    </Svg>
)

export const DrawIcon = () => (
    <Svg>
        <rect x="4" y="12" width="12" height="17" rx="2" transform="rotate(-8 10 20.5)" />
        <rect x="17" y="4" width="12" height="17" rx="2" transform="rotate(8 23 12.5)" />
        <path d="M23 8v9M18.5 12.5h9" />
    </Svg>
)

export const RevealIcon = () => (
    <Svg>
        <rect x="4.5" y="9" width="11" height="16" rx="2" />
        <rect x="17.5" y="9" width="10" height="16" rx="2" />
        <path d="M20 14.5h5M20 18h5M20 21.5h3.5" />
        <path d="M8 4.5 10 8M13.5 5.5 12.5 8" />
    </Svg>
)

export const ReadingIcon = () => (
    <Svg>
        <path d="M16 4.5 18.4 12l7.6 2.4-7.6 2.4L16 24.5l-2.4-7.7L6 14.4 13.6 12Z" />
        <path d="M25 22.5 25.9 25l2.6.9-2.6.9-.9 2.5-.9-2.5-2.6-.9 2.6-.9Z" />
    </Svg>
)

export const NewReadingIcon = () => (
    <Svg>
        <path d="M26.5 16a10.5 10.5 0 1 1-3.4-7.7" />
        <path d="M27 5.5V12h-6.4" />
    </Svg>
)

export const BackIcon = () => (
    <Svg>
        <path d="M25 16H8" />
        <path d="M15 25 6 16l9-9" />
    </Svg>
)
